<template>
<div id="trafico" data-app ref="trafico" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Gestión de Embarques" class="elevation-1 px-5 py-3" >

                    <v-card-text>

                        <!-- Buscador -->
                        <v-container grid-list-md style="position: absolute;" >
                            <v-layout wrap>
                                <v-flex xs7>
                                    <v-text-field style="margin-top: -5px; " label="Búsqueda General" v-model="busqueda" @keyup.enter="busquedaGeneral()" ></v-text-field>
                                </v-flex>
                                <v-flex xs4>
                                    <v-btn fab x-small color="primary" @click.native="busquedaGeneral()" title="Realizar Busqueda" v-tippy>
                                        <v-icon>search</v-icon>
                                    </v-btn>
                                    <v-btn fab x-small color="default" @click.native="limpiaBusquedaGeneral()" title="Eliminar Busqueda" v-tippy>
                                        <v-icon>clear</v-icon>
                                    </v-btn>
                                </v-flex>

                                <v-flex xs7>
                                    <v-card class="list-busqueda" v-if="resultadoBusqueda.length > 0" >

                                        <v-list two-line>
                                            <v-subheader>Tráficos</v-subheader>
                                            <template v-for="(trafico, index) in resultadoBusqueda" >

                                                <v-list-item :key="trafico.referencia" @click="seleccionBusqueda(trafico)" >
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            {{ trafico.referencia + ' / ' + trafico.tipo_operacion + ' / ' + trafico.movimientos[trafico.movimientos.length -1].estado }}
                                                        </v-list-item-title>
                                                        <v-list-item-sub-title>
                                                            {{ trafico.responsable_trafico + ' - ' + (trafico.fecha_embarque ? formatDate(trafico.fecha_embarque.substr(0, 10)) : '') }}
                                                        </v-list-item-sub-title>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-divider v-if="index < (resultadoBusqueda.length - 1)" :key="'d' + index" ></v-divider>
                                            </template>
                                        </v-list>
                                    </v-card>
                                </v-flex>
                            </v-layout>

                        </v-container>

                        <!-- Importador -->
                        <v-flex xs12 style="margin-top: 5px; margin-bottom: 20px; " justify-end row fill-height>
                            <v-speed-dial :id="'id-1'" direction="left" open-on-hover>
                                <template v-slot:activator>
                                    <v-btn :id="'id-1'" x-small fab dark color="primary" >
                                        <v-icon>reorder</v-icon>
                                    </v-btn>
                                </template>
                                <exportar-excel :data="datafiltered" :exportFields="traficos.fieldsExcel" name="Tráficos.xlsx" >
                                    <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                                        <v-icon dark>get_app</v-icon>
                                    </v-btn>
                                </exportar-excel>
                                <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload" />
                                <exportar-excel :data="camposLayout" :exportFields="encabezadoLayout" name="Layout Tráficos.xlsx" >
                                    <v-btn fab x-small dark color="purple darken-2" title="Descargar Layout" v-tippy>
                                        <v-icon dark>receipt</v-icon>
                                    </v-btn>
                                </exportar-excel>
                            </v-speed-dial>
                        </v-flex>

                        <v-tabs v-model="tab" grow style="margin-bottom: 30px; " >
                            <v-tabs-slider color="primary" ></v-tabs-slider>

                            <v-tab @click.native="changeTab('Registro')" >Registro</v-tab>
                            <v-tab @click.native="changeTab('Confirmación de Carga')" >Confirmación de Carga</v-tab>
                            <v-tab @click.native="changeTab('Tránsito')" >Tránsito de Puerto</v-tab>
                            <v-tab @click.native="changeTab('Despacho Aduanal')" >Despacho Aduanal</v-tab>
                            <v-tab @click.native="changeTab('Tránsito a Destino')" >Tránsito a Destino</v-tab>
                            <v-tab @click.native="changeTab('Control Administrativo')" >Control Administrativo</v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="tab" >
                        </v-tabs-items>

                        <div id="datagrid" v-on:keyup.enter="$refs.pagination_pw.filterData()" >

                            <v-client-table ref="vuetable" :data="traficos.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>

                                <template slot="responsable_trafico" slot-scope="props" >
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }" >
                                            <span v-on="on" >{{ getInicialesUsuario(props.row.responsable_trafico) }}</span>
                                        </template>
                                        <span>{{ props.row.responsable_trafico }}</span>
                                    </v-tooltip>

                                </template>

                                <template slot="referencia" slot-scope="props" >
                                    <a @click="openModalDetalles(props.row.referencia)" class="show-modal" title="Ver Detalles" v-tippy>{{ props.row.referencia }}</a>
                                </template>

                                <template slot="mensaje" slot-scope="props" >
                                    <a @click="openModalNota(props.row.referencia)" class="show-modal" title="Agregar Nota" v-tippy>
                                        <span v-if="props.row.mensaje != '' && props.row.mensaje != null" >
                                            {{ props.row.mensaje }}
                                        </span>
                                        <span v-else>
                                            ......
                                        </span>
                                    </a>
                                </template>

                                <template slot="subestado" slot-scope="props" >
                                    <a @click="openModalEstado(props.row.referencia, props.row.movimientos)" class="show-modal" title="Cambiar Estado" v-tippy>
                                        {{ props.row.subestado }}
                                    </a>
                                </template>

                                <!-- Contenedores -->
                                <template slot="numero_contenedor" slot-scope="props" >
                                    <div class="text-xs-center" >
                                        <v-menu v-model="props.row[menu + '-' + props.row.numero_contenedor]" :close-on-content-click="false" :nudge-width="200" offset-x>

                                            <template v-slot:activator="{ on }" >
                                                <a class="show-modal" title="Contenedor" v-tippy v-on="on" >
                                                    {{ props.row.numero_contenedor }}
                                                </a>
                                            </template>

                                            <v-card>
                                                <v-list>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-title>Contenedores</v-list-item-title>
                                                            <v-list-item-sub-title>{{ props.row.referencia }}</v-list-item-sub-title>
                                                        </v-list-item-content>

                                                    </v-list-item>
                                                </v-list>

                                                <v-divider></v-divider>

                                                <v-list>
                                                    <v-list-item v-for="item in props.row.detalles_totales" :key="item.index" >
                                                        * {{ item.numero_contenedor }}
                                                    </v-list-item>
                                                </v-list>
                                            </v-card>
                                        </v-menu>
                                    </div>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="'id-2'" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="'id-2'" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="warning" @click.native="editRegistro(props.row.referencia)" title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>

                                        <v-btn x-small fab dark color="blue" @click.native="downloadRegistro(props.row.referencia)" title="Descargar Formato de Impresión" v-tippy>
                                            <v-icon>local_printshop</v-icon>
                                        </v-btn>

                                        <v-btn x-small fab dark color="green" title="Copiar Registro" @click.native="copyRegistro(props.row.referencia)" v-tippy>
                                            <v-icon>file_copy</v-icon>
                                        </v-btn>

                                        <v-btn x-small fab dark color="red" title="Eliminar Registro" @click.native="deleteRegistro(props.row.referencia)" v-tippy>
                                            <v-icon>delete_forever</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                            <template>
                                <div v-if="pwPagination.total > 0" >
                                    <div class="mt-3" >
                                        <PaginacionComponent ref="pagination_pw" :total='pwPagination.total' :links="pwPagination.links" :items="traficos" :options="pwPagination.options" ></PaginacionComponent>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </v-card-text>

                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>

    <!-- Pdf -->
    <div style="display: none;" >
        <v-detalle-carga-component ref="pdf" :modelPdf="modelPdf" />
    </div>

    <!-- Modal estado -->
    <v-dialog v-model="modalEstado" max-width="500px" id="modalestado" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon class="white--text" >swap_horiz</v-icon>&nbsp;
                    {{ referenciaChangeEstado }}
                </v-card>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="modalEstado = false" class="close_modal" >
                    <v-icon class="white--text" >cancel</v-icon>
                </v-btn>
            </v-card-title>

            <v-divider></v-divider>
            <v-card-text>
                <v-form ref="formEstado" lazy-validation>
                    <v-container grid-list-md @keyup.enter="changeEstado()" >
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-select :items="subestados" v-model="modelEstado.movimiento.subestado" label="Estado" item-text="nombre" item-value="nombre" :rules="[rules.required]" ></v-select>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field label="Nota" v-model="modelEstado.nota" ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false"  transition="scale-transition" min-width="290px" offset-y>
                                    <template v-slot:activator="{ on }" >
                                        <v-text-field v-on="on" v-model="modelEstado.movimiento.fecha_real" label="Fecha" color="secondary" prepend-icon="event" @blur="modelEstado.movimiento.fecha_real = parseDate(modelEstado.movimiento.fecha_real)" v-mask="'####-##-##'" :rules="[rules.required, validaFecha]" ></v-text-field>
                                    </template>

                                    <v-date-picker v-model="modelEstado.movimiento.fecha_real" color="secondary"  scrollable locale="es-mx" @input="menu1 = false" >
                                        <v-spacer />

                                        <v-btn color="secondary" x-small @click="menu1 = false" >
                                            Cancelar
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>                                
                            </v-flex>
                        </v-layout>                        
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modalEstado=false" >
                    <v-icon>cancel</v-icon> Cancelar
                </v-btn>
                <v-btn color="success" @click.native="changeEstado()" >
                    <v-icon>done</v-icon>Cambiar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- Modal nota -->
    <v-dialog v-model="modalNota" max-width="500px" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon class="white--text" >swap_horiz</v-icon>&nbsp;
                    {{ referenciaChangeEstado }}
                </v-card>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="modalNota = false" class="close_modal" >
                    <v-icon class="white--text" >cancel</v-icon>
                </v-btn>
            </v-card-title>

            <v-divider></v-divider>
            <v-card-text>
                <v-form ref="formNota" lazy-validation>
                    <v-container grid-list-md @keyup.enter="addNota()" >
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field label="Nota" v-model="modelNota.nota" :rules="[rules.required]" ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modalNota=false" >
                    <v-icon>cancel</v-icon> Cancelar
                </v-btn>
                <v-btn color="success" @click.native="addNota()" >
                    <v-icon>done</v-icon>Agregar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- Modal Detalles -->
    <v-dialog fullscreen v-model="modalDetalles" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon @click="modalDetalles = false" class="white--text" ref="closedetalles" >mdi-close</v-icon>&nbsp;
                    <v-icon v-show="false" @click="openModalDetalles(modelPdf.referencia)" class="white--text" ref="updatedetalles" >mdi-refresh</v-icon>
                    {{ referenciaChangeEstado }}

                </v-card>

            </v-card-title>

            <v-card-text>
                <v-tabs fixed-tabs v-model="tabs" >
                    <v-tab key="mt1" > Datos Embarque </v-tab>
                    <v-tab key="mt2" > Movimientos/Estados </v-tab>
                    <v-tab key="mt3" > Notas/Comentarios </v-tab>
                    <v-tab key="mt4" > Descargar Templates </v-tab>
                    <v-tab key="mt5" > Archivos Adjuntos </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabs" >
                    <v-tab-item  >
                     <v-flex xs12 md12 pa-5>
                         <p class="text-right" >
                                   <v-btn x-small fab dark color="blue" @click.native="downloadRegistro(referenciaChangeEstado)" title="Descargar Formato de Impresión" v-tippy>
                                            <v-icon>local_printshop</v-icon>
                                        </v-btn>
                                </p>
                        
                        <v-detalle-carga-component ref="pdf" :modelPdf="modelPdf" />
                      </v-flex>
                    </v-tab-item>
                    <v-tab-item>
                        <v-layout pa-5  wrap>
                            <v-flex xs12 md12>
                                
                                <p class="text-right" >
                                    <exportar-excel :data="modelPdf.movimientos" :exportFields="camposExcelMovimientos" name="Movimientos.xlsx" >
                                        <v-btn fab dark x-small color="success" title="Exportar a Excel" v-tippy>
                                            <v-icon dark>get_app</v-icon>
                                        </v-btn>
                                    </exportar-excel>
                                </p>

                                <v-client-table width="800px" ref="vuetableMovimientos" :data="modelPdf.movimientos" :columns="columnsEstados" :options="optionsEstados" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                    </template>                                       
                                </v-client-table>
                            </v-flex>
                        </v-layout>
                    </v-tab-item>
                    <v-tab-item>
                        <v-layout pa-5  wrap>
                            <v-flex xs12 md12>
                                <p class="text-right" >
                                    <exportar-excel :data="modelPdf.notas" :exportFields="camposExcelNotas" name="Notas.xlsx" >
                                        <v-btn fab dark x-small color="success" title="Exportar a Excel" v-tippy>
                                            <v-icon dark>get_app</v-icon>
                                        </v-btn>
                                    </exportar-excel>
                                </p>
                                <v-client-table ref="vuetableNotas" :data="modelPdf.notas" :columns="columnsNotas" :options="optionsNotas" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                    </template>                                    
                                </v-client-table>
                            </v-flex>
                        </v-layout>
                    </v-tab-item>
                    <v-tab-item>
                        <v-layout pa-5 wrap>
                          
                            <v-flex xs12 md6 v-for="template in templates.items" :key="template.index" >
                                <v-layout wrap>
                                    <v-flex xs6 v-if="hasSend(template.url)" class="green--text" >
                                        {{ template.nombre }} (enviado)
                                    </v-flex>
                                    <v-flex xs6 v-else>
                                        {{ template.nombre }}
                                    </v-flex>

                                    <v-flex xs6>
                                        <a @click="downloadTemplate(template.url)" title="Descargar Template" v-tippy>
                                            <v-icon left color="primary" >save</v-icon>
                                        </a>

                                        <a @click="openModalcorreo(template.url)" title="Enviar por correo" v-tippy>
                                            <v-icon left color="primary" >email</v-icon>
                                        </a>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-tab-item>
                    <v-tab-item>
                       <v-flex xs12 md12 pa-5>

                        <v-explorer-adjuntos  :adjuntos_array="modelPdf.adjuntos" :referencia="modelPdf.referencia"  />
                      </v-flex>
                        
                    </v-tab-item>
                </v-tabs-items>

            </v-card-text>
            <v-card-actions>
                <!--v-spacer></v-spacer>
                  <v-btn@click.native="modalDetalles = false" >
                    <v-icon>cancel</v-icon> Cancelar
                  </v-btn>
                  <v-btn

                    color="success"
                    @click.native="addNota()"
                  >
                    <v-icon>done</v-icon>Agregar
                  </v-btn-->
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- Modal envio correos -->
    <v-dialog v-model="templates.modalCorreo" max-width="700px" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon class="white--text" >swap_horiz</v-icon>&nbsp;
                    {{ referenciaChangeEstado }}
                </v-card>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="templates.modalCorreo = false" class="close_modal" >
                    <v-icon class="white--text" >cancel</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>

                <v-container>
                    <v-layout wrap>
                        <v-autocomplete v-model="templates.correos" :disabled="false" :items="templates.contactos" fill chips color="blue-grey lighten-2" label="Selecciona los correos a los cuales enviar el template" item-text="name" item-value="name" multiple>

                            <template v-slot:selection="data" >
                                <v-chip :selected="data.selected" close class="chip--select-multi" @input="remove(data.item)" >
                                    {{ data.item.name }}
                                </v-chip>
                            </template>

                            <template v-slot:item="data" >
                                <template v-if="typeof data.item !== 'object'" >
                                    <v-list-item-content v-text="data.item" ></v-list-item-content>
                                </template>
                                <template v-else>
                                    <v-list-item-content>
                                        <v-list-item-title v-html="data.item.name" ></v-list-item-title>
                                    </v-list-item-content>
                                </template>
                            </template>

                        </v-autocomplete>

                        <v-flex xs12>
                            <v-text-field label="Si desea agregar otros correos, agregarlos separados por ';'" v-model="templates.correosExtra" ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="templates.modalCorreo=false" >
                    <v-icon>cancel</v-icon> Cancelar
                </v-btn>
                <v-btn color="success" @click.native="sendMail()" >
                    <v-icon>done</v-icon>Enviar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import html2pdf from "html2pdf.js";
import axios from "axios";
import PaginacionComponent from '@/components/PaginacionComponent.vue';

import pdf from "@/components/trafico/Pdf.vue";
import explorer from "@/components/trafico/ExplorerAdjuntos.vue";

import {
    ServerTable,
    ClientTable,
    Event
} from 'vue-tables-2';

export default {
    name: 'trafico',
    components: {
        "v-detalle-carga-component": pdf,
        "PaginacionComponent": PaginacionComponent,
        "v-explorer-adjuntos": explorer
    },
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.traficos.items;
            }

        },
    },
    created() {
        this.getUsuarios();
    },
    mounted() {
       
        this.getColumnsTabs('Registro');
        this.getTraficos();
       
        this.fillSelects();        
       
        this.model_filters = this.$refs.vuetable.query;
    },
    data() {
        return {
            tabs: null,
            model_filters: '',
            pwPagination: {
                total: 0,
                links: {
                    url: this.$hostname + "traficos/listado/",
                    next: '',
                    prev: '',
                },
                options: {
                    tipo: 1,
                    size: 10,
                    loading: this.showLoading,
                    filters: {
                        rfc: '',
                    }
                }
            },
            name: "datagrid",
            //columnsTab: {},
            columns: ["responsable_trafico", "referencia", "tipo_operacion", "embarcador", "consignatario", "tipo_embarque", "modalidad_transporte", "mensaje", "estado"],
            tab: null,
            tabDetalles: null,
            show_loading: true,
            options: {
                filterable : ["responsable_trafico", "referencia", "tipo_operacion", "embarcador", "consignatario", "tipo_embarque", "modalidad_transporte", "mensaje", "estado"],

                sortable: ["referencia", "responsable_trafico", "referencia", "tipo_operacion", "fecha_recoleccion", "embarcador", "consignatario", "tipo_embarque", "modalidad_transporte", "mensaje", "estado"],

                headings: {},

                orderBy: {
                    column: "referencia",
                    ascending: false
                },

                customFilters: [{
                    name: 'referenciaGeneral',
                    callback: function (row, query) {
                        return row.referencia == query;
                    }
                }]
            },
            breadcrumbs: [        
                {
                    text: "Logística",
                    disabled: false,
                    to: ""
                },
                {
                    text: "Gestión de Embarques",
                    disabled: false,
                    to: ""
                }
            ],
            search: "",
            traficos: {
                items: [],
                fieldsExcel: {}
            },

            columnsEstados: ["fecha", "fecha_real", "estado", "subestado", "usuario"],
            optionsEstados: {
                filterable: [],
                sortable: [],
                headings: {
                    estado: "Estado",
                    subestado: "Subestado",
                    fecha: "Fecha de Registro",
                    fecha_real: "Fecha Movimiento Real",
                    usuario: "Usuario",
                }
            },
            camposExcelMovimientos: {
                "Fecha de Registro": "fecha",
                "Fecha Movimiento Real": "fecha_real",
                Estado: "estado",
                Subestado: "subestado",
                Usuario: "usuario",
            },

            columnsNotas: ["estado","subestado","nota.fecha", "nota.nota", "nota.usuario"],
            optionsNotas: {
                filterable: [],
                sortable: [],
                headings: {
                    "nota.fecha": "Fecha",
                    "nota.nota": "Nota",
                    "nota.usuario": "Usuario",
                }
            },
            camposExcelNotas: {
                Estado:"estado",
                Subestado:"subestado",
                Fecha: "nota.fecha",
                Nota: "nota.nota",
                Usuario: "nota.usuario",
            },

            modelPdf: {
                tipo_operacion: "",
                responsable_trafico: "",
                nombre_trafico: "",
                referencia: "",
                fecha_embarque: "",
                fecha_llegada: "",
                agente_aduanal: "",

                aduana_despacho: "",
                agente_carga: "",
                referencia_hbl: "",
                booking: "",
                puerto_embarque: "",
                modalidad_transporte: "",
                tipo_embarque: "",
                transportista_master: "",
                referencia_master: "",
                recinto_fiscal: "",

                detalles_carga: [],
                embarques: [],
                transportes: [],
                alertas: [],
                facturas: [],

                movimientos: [],
                notas: [], //se obtiene del campo movimiento.nota
            },
            selectedTab: 'Registro',
            rules: {
                required: v => !!v || 'Este campo es requerido',
            },

            modalEstado: false,
            referenciaChangeEstado: '',
            menu1: false,
            dateEstado: '',
            subestados: [],
            modelEstado: {
                referencia: '',
                nota: '',
                movimiento: {
                    estado: "",
                    subestado: "",
                    usuario: "",
                    fecha: "",
                    fecha_real: '',
                },
            },
            modalNota: false,
            modelNota: {
                nota: "",
                usuario: "",
                fecha: "",
            },

            modalDetalles: false,
            busqueda: '',
            resultadoBusqueda: [],

            combos: {
                responsables: [],
                agentesAduanales: [],
                aduanasDespacho: [],
                agentesCarga: [],
                modalidadTransportes: [],
                transportistasMaster: [],
                recintosFiscal: [],
                tiposEmbarque: [],
                tiposOperacion: [],
                tipos: [],
                emisores: [],
                embarcadores: [],
                paises_emisor: [],
                paises_embarcador: [],

                agentesAduanalesCompletos: [],
                aduanasDespachoCompletos: [],
            },

            encabezadoLayout: {
                tipo_operacion: 'tipo_operacion',
                responsable_trafico: 'responsable_trafico',
                nombre_trafico: 'nombre_trafico',
                fecha_embarque: 'fecha_embarque',
                fecha_llegada: 'fecha_llegada',
                agente_aduanal: 'agente_aduanal',
                agente_carga: 'agente_carga',
                referencia_hbl: 'referencia_hbl',
                booking: 'booking',
                puerto_embarque: 'puerto_embarque',
                aduana_despacho: 'aduana_despacho',
                modalidad_transporte: 'modalidad_transporte',
                tipo_embarque: 'tipo_embarque',
                transportista_master: 'transportista_master',
                referencia_master: 'referencia_master',
                recinto_fiscalizado: 'recinto_fiscal',

                num_bultos: 'num_bultos',
                tipo_bultos: 'tipo_bultos',
                peso_neto: 'peso_neto',
                peso_bruto: 'peso_bruto',
                vol_cbm: 'vol_cbm',
                numero_contenedor: 'numero_contenedor',
                tipo_contenedor: 'tipo',

                descripcion: 'descripcion',
                tipo_especificacion_embarque: 'tipo_especificacion_embarque',
                emisor: 'emisor',
                embarcador: 'embarcador',
                rfc_tax_id: 'rfc_tax_id',
                pais_procedencia_destino: 'pais_procedencia_destino',
                consignatario1: 'consignatario1',
                consignatario2: 'consignatario2',
                consignatario3: 'consignatario3',
                otro: 'otro',

                transportista: 'transportista',
                rfc: 'rfc',
                ruta_origen: 'ruta_origen',
                ruta_destino: 'ruta_destino',
                tarifa: 'tarifa',
            },
            camposLayout: [{
                tipo_operacion: 'Clave de la Operación',
                responsable_trafico: 'Correo del responsable',
                nombre_trafico: '',
                fecha_embarque: 'dd-mm-YYYY',
                fecha_llegada: 'dd-mm-YYYY',
                agente_aduanal: 'Metadato del agente',
                agente_carga: 'Metadato del agente',
                referencia_hbl: '',
                booking: '',
                puerto_embarque: '',
                aduana_despacho: 'Clave de la aduana',
                modalidad_transporte: '',
                tipo_embarque: 'Clave',
                transportista_master: 'Metadato del transportista',
                referencia_master: '',
                recinto_fiscalizado: '',

                num_bultos: '',
                tipo_bultos: '',
                peso_neto: '',
                peso_bruto: '',
                vol_cbm: '',
                numero_contenedor: '',
                tipo: 'Clave del tipo_contenedor',

                descripcion: '',
                tipo_especificacion_embarque: '1 = Emisor - Destinatario, 2 = Embarcador - Consignatario',
                emisor: 'Metadato del Emisor',
                embarcador: 'Metadato del Embarcador',
                rfc_tax_id: '',
                pais_procedencia_destino: 'clave_m3',
                consignatario1: 'Metadato del Consignatario',
                consignatario2: 'Metadato del Consignatario',
                consignatario3: 'Metadato del Consignatario',
                otro: '',

                transportista: 'Metadato del transportista',
                rfc: '',
                ruta_origen: '',
                ruta_destino: '',
                tarifa: '',
            }],

            menu: false,
            templates: {
                id: '',
                correosExtra: '',
                items: [],
                referencia: '',
                modalCorreo: false,
                correos: [],
                contactos: [],
                alertas: [],
                emails_enviados: [],
            },
            usuarios: [],
        };
    },
    watch: {        
        model_filters: {
            handler(val) {
                this.pwPagination.options.filters = {
                    rfc: this.$local_storage.get("rfc"),
                    tab: this.selectedTab,
                    // referencia: {
                    //   '$regex': this.model_filters.referencia
                    // },
                    // tipo_operacion: {
                    //   '$regex': this.model_filters.tipo_operacion
                    // },
                    // responsable_trafico: {
                    //   '$regex': this.model_filters.responsable_trafico
                    // },
                    // embarques: {
                    //   '$elemMatch': {
                    //     especificaciones: {
                    //       '$elemMatch': {
                    //         embarcador: {
                    //           '$regex': this.model_filters.embarcador
                    //         }
                    //       }
                    //     }
                    //   }
                    // }

                }
            },
            deep: true
        }
    },
    methods: {
       
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`;
        },
        invertDate(date) {
            if (!date) return null

            const [day, month, year] = date.split('/')

            return `${year}-${month}-${day}`;
        },
        showLoading: function () {
            return this.show_loading = !this.show_loading;
        },
        getTraficos: function (tab_in = null, id = null) {
            try {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let rfc = this.$local_storage.get("rfc");

                let data = {
                    rfc: rfc,
                    tab: this.selectedTab,
                    id: id
                }
                this.pwPagination.options.filters.tab = this.selectedTab;
                //data = { "rfc":"MOLG9106088U1" };

                axios
                    .post(this.$hostname + "traficos/listado/", data)
                    .then(response => {
                        if (typeof response.data.results !== "undefined") {
                            // Se filtran los datos por pestaña
                            let selectedTab = this.selectedTab;

                            // Se asignan datos para la paginacion
                            this.pwPagination.total = response.data.count;
                            this.pwPagination.links.next = response.data.next;
                            this.pwPagination.links.prev = response.data.previous;

                            if (tab_in == true && this.$refs.pagination_pw != undefined) {
                                this.$refs.pagination_pw.activePage = 0;
                                this.$refs.pagination_pw.total_items = this.pwPagination.total;
                            }

                            let datosTab = response.data.results.filter((elemento) => {
                                let movimientos = elemento.movimientos;

                                if (movimientos.length > 0)
                                    return movimientos[movimientos.length - 1].estado == selectedTab;
                            });

                            this.traficos.items = datosTab;
                        }

                        this.$root.$dialogLoader.hide();
                    })
                    .catch(error => {
                        console.log(error);
                        this.$root.$dialogLoader.hide();
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener los tráficos.",
                            footer: ""
                        });
                    });
            } catch (error) {
                console.log(error);
            }

        },
        createRegistro: function () {
            this.$local_storage.set("referencia", "");
            this.$local_storage.set("update", false);
            this.$store.state.embarques_trafico = [];
            this.$store.state.transportes_trafico = [];
            this.$store.state.alertas_trafico = [];

            this.$router.push("/nuevo_trafico");
        },
        editRegistro: function (referencia) {
            this.$local_storage.set("referencia", referencia);
            this.$local_storage.set("update", true);
            this.$router.push("/nuevo_trafico");
        },
        getTraficoDetalles: async function (referencia) {
            var rfc = this.$local_storage.get("rfc");

            let data = {
                rfc: rfc,
                referencia: referencia
            };

            let response = await axios.post(this.$hostname + "traficos/obtener/", data);
            return response.data;
        },
      
        downloadRegistro: function (referencia) {
            var rfc = this.$local_storage.get("rfc");
            
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: rfc,
                referencia: referencia
            };

            axios
                .post(this.$hostname + "traficos/obtener/", data, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then(response => {
                    let html = "";

                    for (let key in response.data) {
                        this.modelPdf[key] = response.data[key];
                    }

                    var opt = {
                        margin: [1, 0.5, 1, 0.5], //top, left, bottom, right
                        filename: referencia + ".pdf",
                        image: {
                            type: "jpeg",
                            quality: 0.5
                        },
                        html2canvas: {
                            scale: 2
                        },
                        pagebreak: {
                            mode: ["avoid-all", "css", "legacy"]
                        },
                        jsPDF: {
                            unit: "in",
                            format: "letter",
                            orientation: "landscape"
                        }
                    };

                    //return;

                    html2pdf()
                        .set(opt)
                        .from(document.getElementById("pdf"))
                        .save();
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el tráfico",
                        footer: ""
                    });
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        copyRegistro: function (referencia) {
            let rfc = this.$local_storage.get("rfc");
            //rfc = 'MOLG9106088U1';

            let data = {
                rfc: rfc,
                referencia: referencia,
            };

            axios
                .post(this.$hostname + "traficos/obtener/", data, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then(response => {
                    response.data.referencia = '';
                    response.data.usuario = this.$local_storage.get("nombre_usuario");

                    axios
                        .post(this.$hostname + "traficos/", response.data)
                        .then(response => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El tráfico se copió correctamente.",
                                footer: ""
                            });

                            this.getTraficos();
                        }).catch(error => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: 'Ocurrió un error al copiar el tráfico.',
                                footer: ""
                            });
                        });
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener el tráfico',
                        footer: ""
                    });
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                    this.formUpdated = false;
                });
        },
        deleteRegistro: function (referencia) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let rfc = this.$local_storage.get("rfc");
                //rfc = 'MOLG9106088U1';

                let data = {
                    rfc: rfc,
                    referencia: referencia,
                };

                if (result.value)
                    axios
                    .delete(this.$hostname + "traficos/0/", {
                        data: data
                    }, {
                        "Content-type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                        "cache-control": "no-cache"
                    })
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El tráfico se eliminó correctamente.",
                            footer: ""
                        });

                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: 'Ocurrió un error al elimira el tráfico',
                            footer: ""
                        });
                    })
                    .then(() => {
                        this.formUpdated = false;
                        this.getTraficos();
                        //this.$root.$dialogLoader.hide();            
                    });

            });
        },
        getColumnsTabs: function (estado) {
            let tabs = [
                'Registro', 'Confirmación de Carga', 'Tránsito', 'Despacho Aduanal', 'Tránsito a Destino', 'Control Administrativo',
            ];

            this.tab = tabs.indexOf(estado);
            let tab_id = this.tab + 1;
            let idCliente = this.$local_storage.get("id_cliente");
            //idCliente = 52;

            axios
                .post(this.$hostname + "catalogos/estados_trafico/list_columnas/", {
                    "cliente": idCliente
                })
                .then(response => {
                    let camposColumna = response.data.filter((columna) => {
                        return columna.id_estado_trafico == tab_id && columna.visible == true;
                    });
                  
                    this.columns = [];
                    this.traficos.fieldsExcel = {};
                    this.options.headings = {};

                    for (var i = 0; i < camposColumna.length; i++) {
                        if (camposColumna[i].campo == null || camposColumna[i].campo == undefined) {
                            continue;
                        }
                        this.columns.push(camposColumna[i].campo);
                        this.options.headings[camposColumna[i].campo] = camposColumna[i].header;

                        this.traficos.fieldsExcel[camposColumna[i].header] = camposColumna[i].campo;
                    }

                    this.columns.push('actions');
                    this.options.headings['actions'] = "Operaciones";
                   
                }).catch(error => {
                    this.$root.$dialogLoader.hide();
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los tráficos.",
                        footer: ""
                    });
                });
        },
        changeTab: function (tab, id = null) {
            Event.$emit('vue-tables.filter::referenciaGeneral', '');
            this.selectedTab = tab;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.getColumnsTabs(tab);
            this.getTraficos(true, id);
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return this.$moment(String(date)).format("YYYY-MM-DD");
        },
        validaFecha: function(fecha){
             if (fecha == "Invalid date")
                return "Fecha no válida.";
            else 
              return true;
        },
        openModalEstado: function (referencia, movimientos) {
            this.modalEstado = true;
            this.referenciaChangeEstado = referencia;
            this.modelEstado.referencia = referencia;
            this.modelEstado.movimiento.subestado = '';
            this.modelEstado.nota = '';
            this.modelEstado.movimiento.fecha_real = this.$moment(new Date()).format("YYYY-MM-DD");

            let subestado = movimientos[movimientos.length - 1].subestado;
            let idCliente = this.$local_storage.get("id_cliente");
            //idCliente = 52;

            axios
                .post(this.$hostname + "catalogos/estados_trafico/list_cliente/", {
                    "cliente": idCliente
                })
                .then(response => {
                    let datos = [];

                    // Se obtiene el orden para continuar con los estados siguientes
                    let orden = response.data.filter((movimiento) => {
                        return movimiento.nombre == subestado;
                    })[0].orden;

                    // Regresa los subestados activos y orden mayor al actual hasta encontrar un requerido
                    for (var i = 0; i < response.data.length; i++) {
                        if (response.data[i].activo == 1 && response.data[i].orden > orden) {
                            datos.push(response.data[i])

                            if (response.data[i].requerido)
                                break;
                        }
                    }

                    this.subestados = datos;
                }).catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener los estados.',
                        footer: ""
                    });
                });
        },
        changeEstado: function () {
            if (this.$refs.formEstado.validate()) {
                this.modelEstado.movimiento.fecha = this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
                this.modelEstado.movimiento.usuario = this.$local_storage.get("nombre_usuario");
                let subestados = this.subestados.filter((subestado) => {
                    return subestado.nombre == this.modelEstado.movimiento.subestado;
                });

                this.modelEstado.movimiento.estado = subestados[0].estado_trafico.nombre;

                if (this.modelEstado.nota != '') {

                    this.modelEstado.movimiento.nota = {
                        nota: this.modelEstado.nota,
                        usuario: this.$local_storage.get("nombre_usuario"),
                        fecha: this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                    }
                }

                axios
                    .put(this.$hostname + "traficos/cambiar_estatus/", this.modelEstado)                    
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El estado se cambió correctamente.",
                            footer: ""
                        });

                        this.getTraficos();
                        this.modalEstado = false;
                    }).catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: 'Ocurrió un error al cambiar el estado.',
                            footer: ""
                        });
                    });
            }
        },
        openModalNota: function (referencia, movimientos) {
            this.modalNota = true;
            this.modelNota.nota = '';
            this.referenciaChangeEstado = referencia;
        },
        addNota: function () {
            let data = {
                referencia: this.referenciaChangeEstado,
                nota: {
                    nota: this.modelNota.nota,
                    usuario: this.$local_storage.get("nombre_usuario"),
                    fecha: this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                }
            }

            if (this.$refs.formNota.validate()) {
                axios
                    .put(this.$hostname + "traficos/comentario/", data)
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "La nota se agregó correctamente.",
                            footer: ""
                        });

                        this.getTraficos();
                        this.modalNota = false;
                    }).catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: 'Ocurrió un error al agregar la nota.',
                            footer: ""
                        });
                    });
            }

        },
        openModalDetalles: async function (trafico) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.referenciaChangeEstado = trafico;
            var rfc = this.$local_storage.get("rfc");
            let datos = await this.getTraficoDetalles(trafico);

            this.modelPdf = datos;
            for(var k in this.modelPdf.movimientos){
                this.modelPdf.movimientos[k].fecha = this.formatDate(this.modelPdf.movimientos[k].fecha.substr(0, 10));
                if(this.modelPdf.movimientos[k].fecha_real != undefined)
                    this.modelPdf.movimientos[k].fecha_real = this.formatDate(this.modelPdf.movimientos[k].fecha_real.substr(0, 10));
            }
            this.modelPdf.notas = this.getNotas(this.modelPdf.movimientos);
            this.templates.referencia = datos.referencia;
            this.templates.alertas = datos.alertas;
            this.templates.emails_enviados = datos.emails_enviados;
            this.getTemplates();
            this.modalDetalles = true;
            this.$root.$dialogLoader.hide();
            
           
        },
        getNotas: function (movimientos) {
            var notas = [];
            var self = this;
            movimientos.forEach(element => {
                if (element.nota.length > 0) {
                    element.nota.forEach(n => {
                        n.fecha = self.formatDate(n.fecha.substr(0, 10));
                        var notaFormada = {"nota":n, "estado":element.estado, "subestado":element.subestado};
                        notas.push(notaFormada);
                    });

                }

            });
          
            return notas;

        },
        busquedaGeneral: function () {
            if (this.busqueda != '') {
                var rfc = this.$local_storage.get("rfc");
                //rfc = 'MOLG9106088U1';

                let data = {
                    "rfc": rfc,
                    "texto": this.busqueda
                };
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                axios
                    .post(this.$hostname + "traficos/search/", data, {
                        "Content-type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                        "cache-control": "no-cache"
                    })
                    .then(response => {
                        this.resultadoBusqueda = [];

                        if (response.data.length > 0)
                            this.resultadoBusqueda = response.data;
                        else
                            this.$swal({
                                type: "info",
                                title: "Aviso",
                                text: "No se encontraron tráficos en la búsqueda",
                                footer: ""
                            });
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener el tráfico",
                            footer: ""
                        });
                    })
                    .then(() => {
                        this.$root.$dialogLoader.hide();
                    });
            }

        },
        validaNombreTrafico: function (nombre) {
            if (nombre) {
                if (nombre.toString().length > 75)
                    return false;
                //JEMM - (21-01-2020): Lourdes solicitó este cambio en reunión en Ags el 10-01-2020            
                //"Sólo se permiten números, letras, guiones medio y bajo"
                const pattern = /^[-_A-Za-z0-9]+$/;
                return pattern.test(nombre);
            }
            return true;
        },
        limpiaBusquedaGeneral: function () {
            this.busqueda = '';
            this.resultadoBusqueda = [];
            this.changeTab(this.selectedTab);
        },
        seleccionBusqueda: function (trafico) {
            this.resultadoBusqueda = [];
            let movimiento = trafico.movimientos[trafico.movimientos.length - 1];
            let estado = movimiento.estado;

            this.getColumnsTabs(estado);
            this.changeTab(estado, trafico.id);
            Event.$emit('vue-tables.filter::referenciaGeneral', trafico.referencia);
        }, //delete
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        handleSuccess: async function ({
            results,
            header
        }) {
            this.importData = results;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            // Validaciones
            for (var i = 0; i < this.importData.length; i++) {
                let errores = '';

                // Tipos de operacion
                if (this.importData[i]['tipo_operacion'] == undefined || (this.importData[i]['tipo_operacion'] != undefined && !this.combos.tiposOperacion.includes(this.importData[i]['tipo_operacion'].toString().trim())))
                    errores += '* Error en el tipo_operacion';

                // Responsables
                if (this.importData[i]['responsable_trafico'] == undefined || (this.importData[i]['responsable_trafico'] != undefined && !this.combos.responsables.includes(this.importData[i]['responsable_trafico'].trim())))
                    errores += '<br/>* Error en el responsable_trafico';

                if (this.importData[i]['nombre_trafico'] != undefined && !this.validaNombreTrafico(this.importData[i]['nombre_trafico']))
                    errores += '<br/>* Error en nombre_trafico: Sólo se permiten 75 caractéres; números, letras, guiones medio y bajo';

                // Agentes aduanales
                if (this.importData[i]['agente_aduanal'] == undefined || (this.importData[i]['agente_aduanal'] != undefined && !this.combos.agentesAduanales.includes(this.importData[i]['agente_aduanal'].trim())))
                    errores += '<br/>* Error en el agente_aduanal';

                // Aduanas despacho
                if (this.importData[i]['aduana_despacho'] == undefined || (this.importData[i]['aduana_despacho'] != undefined && !this.combos.aduanasDespacho.includes(String(this.importData[i]['aduana_despacho']).trim())))
                    errores += '<br/>* Error en el aduana_despacho';
                // Agentes carga
                if (this.importData[i]['agente_carga'] != undefined && !this.combos.agentesCarga.includes(this.importData[i]['agente_carga'].trim()))
                    errores += '<br/>* Error en el agente_carga';

                // Modalidad Transporte
                if (this.importData[i]['modalidad_transporte'] != undefined && !this.combos.modalidadTransportes.includes(String(this.importData[i]['modalidad_transporte'].trim())))
                    errores += '<br/>* Error en el modalidad_transporte';

                // Tipos Embarque
                if (this.importData[i]['tipo_embarque'] != undefined && !this.combos.tiposEmbarque.includes(this.importData[i]['tipo_embarque'].trim()))
                    errores += '<br/>* Error en el tipo_embarque';

                // Transportistas
                if (this.importData[i]['transportista_master'] != undefined && !this.combos.transportistasMaster.includes(this.importData[i]['transportista_master'].trim()))
                    errores += '<br/>* Error en el transportista_master';

                // Recintos Fisxales
                if (this.importData[i]['recinto_fiscalizado'] != undefined && !this.combos.recintosFiscal.includes(this.importData[i]['recinto_fiscalizado'].trim()))
                    errores += '<br/>* Error en el recinto_fiscalizado';

                // Tipos
                if (this.importData[i]['tipo_contenedor'] == undefined || (this.importData[i]['tipo_contenedor'] != undefined && !this.combos.tipos.includes(String(this.importData[i]['tipo_contenedor']))))
                    errores += '<br/>* Error en el tipo_contenedor';

                // tipo_especificacion_embarque
                if (this.importData[i]['tipo_especificacion_embarque'] == false || this.importData[i]['tipo_especificacion_embarque'] == undefined)
                    errores += '<br/>* La tipo_especificacion_embarque es obligatoria';

                // Validar dependiendo del tipo se tome emisor o embarcador
                if (this.importData[i]['tipo_especificacion_embarque'] == '1') {
                    if (this.importData[i]['emisor'] == undefined)
                        errores += '<br/>* El emisor es requerido';
                    else {
                        this.importData[i]['emisor'] = this.importData[i]['emisor'].toString();

                        // Emisor
                        if (!this.combos.emisores.includes(this.importData[i]['emisor']))
                            errores += '<br/>* Error en el emisor';

                        let position = this.combos.emisores.indexOf(this.importData[i]['emisor']);

                        if (this.combos.rfc_emisor[position] != this.importData[i]['rfc_tax_id'])
                            errores += '<br/>* El rfc_tax_id no corresponde al emisor';

                        // Paises
                        if (!this.combos.paises_emisor.includes(this.importData[i]['pais_procedencia_destino']) &&
                            this.importData[i]['pais_procedencia_destino'] != undefined)
                            errores += '<br/>* Error en el pais_procedencia_destino';
                    }
                }

                // Validar dependiendo del tipo se tome emisor o embarcador
                if (this.importData[i]['tipo_especificacion_embarque'] == '2') {
                    if (this.importData[i]['embarcador'] == undefined)
                        errores += '<br/>* El embarcador es requerido';
                    else {
                        this.importData[i]['embarcador'] = this.importData[i]['embarcador'].toString();

                        // Embarcador
                        if (!this.combos.embarcadores.includes(this.importData[i]['embarcador']))
                            errores += '<br/>* Error en el embarcador';

                        let position = this.combos.emisores.indexOf(this.importData[i]['emisor']);

                        if (this.combos.rfc_embarcador[position] != this.importData[i]['rfc_tax_id'])
                            errores += '<br/>* El rfc_tax_id no corresponde al emisor';

                        // Paises
                        if (!this.combos.paises_embarcador.includes(this.importData[i]['pais_procedencia_destino']) &&
                            this.importData[i]['pais_procedencia_destino'] != undefined)
                            errores += '<br/>* Error en el pais_procedencia_destino';
                    }
                }

                // Descripcion
                if (this.importData[i]['descripcion'] == false || this.importData[i]['descripcion'] == undefined)
                    errores += '<br/>* La descripcion es obligatoria';

                // Consignatario 1
                if (this.importData[i]['consignatario1'] != undefined && !this.combos.embarcadores.includes(this.importData[i]['consignatario1'].trim()))
                    errores += '<br/>* Error en el consignatario1';

                // Consignatario 2
                if (this.importData[i]['consignatario2'] != undefined && !this.combos.embarcadores.includes(this.importData[i]['consignatario2'].trim()))
                    errores += '<br/>* Error en el consignatario2';

                // Consignatario 3
                if (this.importData[i]['consignatario3'] != undefined && !this.combos.embarcadores.includes(this.importData[i]['consignatario3'].trim()))
                    errores += '<br/>* Error en el consignatario3';

                // Transportistas
                if (this.importData[i]['transportista'] != undefined && !this.combos.transportistasMaster.includes(this.importData[i]['transportista'].trim()))
                    errores += '<br/>* Error en el transportista';

                // Fecha Embarque
                if (this.importData[i]['fecha_embarque'] != undefined)
                    this.importData[i]['fecha_embarque'] = this.validateDate(this.importData[i]['fecha_embarque']);
                else
                    errores += '<br/>* Error en la fecha_embarque';

                if (this.importData[i]['fecha_embarque'] == false)
                    errores += '<br/>* Error en la fecha_embarque';

                // Fecha Llegada
                if (this.importData[i]['fecha_llegada'] != undefined)
                    this.importData[i]['fecha_llegada'] = this.validateDate(this.importData[i]['fecha_llegada']);
                else
                    errores += '<br/>* Error en la fecha_llegada';

                if (this.importData[i]['fecha_llegada'] == false)
                    errores += '<br/>* Error en la fecha_llegada';

                if (errores != '') {
                    this.$root.$dialogLoader.hide();

                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: 'Existen errores en el renglón ' + (i + 2) + '. Corrija y vuelva a intentarlo.',
                        footer: errores
                    });

                    return false;
                }
            }

            let correcto = await this.importExcel();
            this.$root.$dialogLoader.hide();
            this.getTraficos();

            if (correcto == true)
                this.$swal({
                    type: "success",
                    title: "Operación Exitosa",
                    text: "El archivo se importó correctamente.",
                    footer: ""
                });
            else if (correcto == 'errores')
                return false;
            else
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "El archivo se importó con errores.",
                    footer: ""
                });

            return true;
        },
        validateDate: function (date) {
            if (date == '')
                return false;

            let fecha = '';

            if (date.toString().indexOf('/') != -1 || date.toString().indexOf('-') != -1)
                fecha = this.$moment(String(date)).format("YYYY-MM-DD");
            else
                fecha = this.$moment((date - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");

            if (fecha == 'Invalid date')
                return false;
            else
                return fecha;
        },
        getUsuarios: function () {
            let idCliente = this.$local_storage.get("id_cliente");

            let data = {
                cliente: idCliente,
                sistema: this.$sistema
            };
            axios
                .post(this.$hostname + "usuarios/obtener_usuarios_cliente/", data)
                .then(response => {
                    this.usuarios = response.data;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los usuarios.",
                        footer: ""
                    });
                });
        },
        getInicialesUsuario: function (correoUsuario) {
            let filter = this.usuarios.filter((user) => {
                return user.email.toString().toLowerCase() == correoUsuario.toString().toLowerCase();
            });

            if (filter.length > 0) {
                if (filter[0].iniciales != null && filter[0].iniciales != "")
                    return filter[0].iniciales;
                else
                    return correoUsuario;
            } else {
                return correoUsuario;
            }
        },
        fillSelects() {
            this.id_cliente = this.$local_storage.get("id_cliente");

            // responsables
            axios.post(this.$hostname + "usuarios/obtener_usuarios_cliente/", {
                    'cliente': this.id_cliente,
                    'sistema': this.$sistema
                }, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then(response => {
                    let datos = [];

                    for (var i = 0; i < response.data.length; i++)
                        datos.push(response.data[i].email);

                    this.combos.responsables = datos;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener los responsables',
                        footer: ""
                    });
                });

            // agentesAduanales
            axios.post(this.$hostname + "catalogos/agentes_aduanales/get_agentes/", {
                    "cliente": this.id_cliente
                }, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then(response => {
                    let datos = [];
                    let datosCompletos = [];

                    for (var i = 0; i < response.data.length; i++) {
                        datos.push(response.data[i].metadato);

                        datosCompletos.push({
                            'id': response.data[i].id_agente_aduanual,
                            'nombre': response.data[i].metadato,
                        });

                    }

                    this.combos.agentesAduanales = datos;
                    this.combos.agentesAduanalesCompletos = datosCompletos;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener los agentes aduanales',
                        footer: ""
                    });
                });

            // aduanasDespacho
            axios.get(this.$hostname + "catalogos/aduanas/", {
                    "cliente": this.id_cliente
                }, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then(response => {
                    let datos = [];
                    let datosCompletos = [];

                    for (var i = 0; i < response.data.length; i++) {
                        datos.push(response.data[i].clave);

                        datosCompletos.push({
                            'id': response.data[i].clave,
                            'nombre': response.data[i].nombre,
                        });

                    }

                    this.combos.aduanasDespacho = datos;
                    this.combos.aduanasDespachoCompletos = datosCompletos;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener las aduanas',
                        footer: ""
                    });
                });

            // agentesCarga
            axios.post(this.$hostname + "catalogos/agentes_carga/get_agentes_carga/", {
                    "cliente": this.id_cliente
                }, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then(response => {
                    let datos = [];

                    for (var i = 0; i < response.data.length; i++)
                        datos.push(response.data[i].metadato);

                    this.combos.agentesCarga = datos;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener los agentes de carga',
                        footer: ""
                    });
                });

            // modalidadTransportes
            axios.post(this.$hostname + "apendices/lista/", {
                    "tabla": 1
                }, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then(response => {
                    let datos = [];

                    for (var i = 0; i < response.data.length; i++)
                        datos.push(response.data[i].descripcion);

                    this.combos.modalidadTransportes = datos;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener los tipos de transporte',
                        footer: ""
                    });
                });

            // transportistasMaster
            axios.post(this.$hostname + "catalogos/transportistas/get_transportistas/", {
                    "cliente": this.id_cliente
                }, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then(response => {
                    let datos = [];

                    for (var i = 0; i < response.data.length; i++)
                        datos.push(response.data[i].metadato);

                    this.combos.transportistasMaster = datos;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener los transportistas',
                        footer: ""
                    });
                });

            // recintosFiscal
            axios.post(this.$hostname + "apendices/lista/", {
                    "tabla": 18
                }, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then(response => {
                    let datos = [];

                    for (var i = 0; i < response.data.length; i++)
                        datos.push(response.data[i].descripcion);

                    this.combos.recintosFiscal = datos;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener los recintos fiscales',
                        footer: ""
                    });
                });

            // tiposEmbarque
            axios.post(this.$hostname + "apendices/lista/", {
                    "tabla": 20
                }, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then(response => {
                    let datos = [];

                    for (var i = 0; i < response.data.length; i++)
                        datos.push(response.data[i].clave);

                    this.combos.tiposEmbarque = datos;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener los tipos de embarque',
                        footer: ""
                    });
                });

            // tiposOperacion
            axios.post(this.$hostname + "apendices/lista/", {
                    "tabla": 21
                }, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then(response => {
                    let datos = [];

                    for (var i = 0; i < response.data.length; i++)
                        datos.push(response.data[i].clave);

                    this.combos.tiposOperacion = datos;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener los tipos de Operación',
                        footer: ""
                    });
                });

            // Tipos
            axios.post(this.$hostname + 'apendices/lista/', {
                    tabla: 3
                }, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then((response) => {
                    let datos = [];

                    for (var i = 0; i < response.data.length; i++)
                        datos.push(response.data[i].clave);

                    this.combos.tipos = datos;
                })
                .catch((err) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Error al obtener los tipos de contenedores"
                    });
                    console.log(err.response);
                });

            // Emisores
            axios.post(this.$hostname + 'catalogos/emisores_destinatarios/get_emisores/', {
                    "cliente": this.id_cliente
                }, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then((response) => {
                    let datos = [];
                    let paises = [];
                    let rfc = [];

                    for (var k in response.data) {
                        rfc.push(response.data[k].rfc);
                        datos.push(response.data[k].metadato);

                        if (response.data[k].pais)
                            paises.push(response.data[k].pais['clave_m3']);
                    }

                    this.combos.emisores = datos;
                    this.combos.paises_emisor = paises;
                    this.combos.rfc_emisor = rfc;
                })
                .catch((err) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Error al obtener los emisores"
                    });
                    console.log(err);
                });

            // Embarcadores
            axios.post(this.$hostname + 'catalogos/embarcadores_consignatarios/get_embarcadores_consignatarios/', {
                    "cliente": this.id_cliente
                }, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then((response) => {
                    let datos = [];
                    let paises = [];
                    let rfc = [];

                    for (var i = 0; i < response.data.length; i++) {
                        rfc.push(response.data[i].rfc);
                        datos.push(response.data[i].metadato);
                        paises.push(response.data[i].pais['clave_m3']);
                    }

                    this.combos.embarcadores = datos;
                    this.combos.paises_embarcador = paises;
                    this.combos.rfc_embarcador = rfc;
                })
                .catch((err) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Error al obtener los Embarcadores"
                    });

                    console.log(err.response);
                });

        },
        importExcel: async function () {

            if (this.importData.length == 0) {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "El archivo no tiene registros: ",
                    footer: ''
                });

                return 'errores';
            }

            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let errores = '';
            let renglones = '';

            for (var i = 0; i < this.importData.length; i++) {
                let agente_aduanal = this.importData[i]['agente_aduanal'];
                let aduana_despacho = this.importData[i]['aduana_despacho'];

                agente_aduanal = this.combos.agentesAduanalesCompletos.find(obj => obj.nombre == agente_aduanal);
                aduana_despacho = this.combos.aduanasDespachoCompletos.find(obj => obj.id == aduana_despacho);

                let datosJson = {
                    referencia: '',
                    rfc: this.$local_storage.get("rfc"),
                    usuario: this.$local_storage.get("nombre_usuario"),
                    tipo_operacion: this.importData[i]['tipo_operacion'],
                    responsable_trafico: this.importData[i]['responsable_trafico'],
                    nombre_trafico: this.importData[i]['nombre_trafico'],
                    fecha_embarque: this.importData[i]['fecha_embarque'] + ' 00:00:01',
                    fecha_llegada: this.importData[i]['fecha_llegada'] + ' 00:00:01',
                    agente_aduanal: {
                        "nombre": agente_aduanal.nombre,
                        "clave": agente_aduanal.id
                    }, //this.importData[i]['agente_aduanal'],
                    agente_carga: this.importData[i]['agente_carga'],
                    referencia_hbl: this.importData[i]['referencia_hbl'],
                    booking: this.importData[i]['booking'],
                    puerto_embarque: this.importData[i]['puerto_embarque'],
                    aduana_despacho: {
                        "nombre": aduana_despacho.nombre,
                        "clave": aduana_despacho.id
                    }, //this.importData[i]['aduana_despacho'],
                    modalidad_transporte: this.importData[i]['modalidad_transporte'],
                    tipo_embarque: this.importData[i]['tipo_embarque'],
                    transportista_master: this.importData[i]['transportista_master'],
                    referencia_master: this.importData[i]['referencia_master'],
                    recinto_fiscal: this.importData[i]['recinto_fiscal'],

                    detalles_carga: [{
                        num_bultos: this.importData[i]['num_bultos'],
                        tipo_bultos: this.importData[i]['tipo_bultos'],
                        peso_neto: this.importData[i]['peso_neto'],
                        peso_bruto: this.importData[i]['peso_bruto'],
                        vol_cbm: this.importData[i]['vol_cbm'],
                        numero_contenedor: this.importData[i]['numero_contenedor'],
                        tipo: this.importData[i]['tipo_contenedor'],
                    }],
                    embarques: [{
                        descripcion: this.importData[i]['descripcion'],
                        especificaciones: [{
                            tipo: this.importData[i]['tipo_especificacion_embarque'],
                            embarcador: this.importData[i]['embarcador'] == undefined ? '' : this.importData[i]['embarcador'],
                            emisor: this.importData[i]['emisor'] == undefined ? '' : this.importData[i]['emisor'],
                            rfc_tax_id: this.importData[i]['rfc_tax_id'],
                            pais_procedencia_destino: this.importData[i]['pais_procedencia_destino'],
                            consignatario1: this.importData[i]['consignatario1'] == undefined ? '' : this.importData[i]['consignatario1'],
                            consignatario2: this.importData[i]['consignatario2'] == undefined ? '' : this.importData[i]['consignatario2'],
                            consignatario3: this.importData[i]['consignatario3'] == undefined ? '' : this.importData[i]['consignatario3'],
                            otro: this.importData[i]['otro'] == undefined ? '' : this.importData[i]['otro'],
                        }]
                    }],
                    transportes: [{
                        transportista: this.importData[i]['transportista'],
                        rfc: this.importData[i]['rfc'],
                        ruta_origen: this.importData[i]['ruta_origen'],
                        ruta_destino: this.importData[i]['ruta_destino'],
                        tarifa: this.importData[i]['tarifa'],
                    }],
                    emails_enviados: []
                };

                let response = await axios.post(this.$hostname + "traficos/", datosJson)

                    .catch(error => {
                        for (let key in error.response.data)
                            errores += '<br/>* Error en ' + key + ': ' + error.response.data[key];

                        return false;
                    });

                if (response == false)
                    renglones += (i + 3) + ', ';

            }

            if (renglones != '') {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error en el renglon " + renglones,
                    footer: errores
                });

                return 'errores';
            }

            return true;
        },
        getTemplates: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            axios
                .post(this.$hostname + "catalogos/templates/list_cliente/", {
                    'cliente': this.$local_storage.get("id_cliente")
                })
                .then(response => {
                    this.templates.items = response.data;
                    this.$root.$dialogLoader.hide();
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los templates.",
                        footer: ""
                    });
                    this.$root.$dialogLoader.hide();
                });

            let contactos = [];

            for (var i = 0; i < this.templates.alertas.length; i++)
                contactos.push({
                    name: this.templates.alertas[i].email
                });

            this.templates.contactos = contactos;
        },
        remove(item) {
            const index = this.templates.correos.indexOf(item.name)
            if (index >= 0) this.templates.correos.splice(index, 1)
        },
        openModalcorreo(id) {
            this.templates.modalCorreo = true
            this.templates.id = id;
        },
        sendMail: function () {
            let extras = this.templates.correosExtra.split(';');
            this.templates.correos = this.templates.correos.concat(extras);

            let id = this.templates.id;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var referencia = this.templates.referencia;
            var rfc = this.$local_storage.get("rfc");

            if (this.templates.correos.length > 0)
                axios
                .post(this.$hostname + "catalogos/templates/download/", {
                    id: id,
                    referencia: referencia,
                    rfc: rfc,
                    correos: this.templates.correos
                }, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Allow": "POST",
                    "cache-control": "no-cache",
                    "responseType": "arraybuffer"
                })
                .then(response => {
                   this.$root.$dialogLoader.hide();
                    this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "El correo se envió correctamente",
                        footer: ""
                    });
                })
                .catch(error => {
                  this.$root.$dialogLoader.hide();
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al descargar el reporte.",
                        footer: ""
                    });
                     
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
            else
                this.$swal({
                    type: "info",
                    title: "Cuidado",
                    text: "Agregue al menos un correo",
                    footer: ""
                });

            this.templates.modalCorreo = false;
            this.templates.correos = [];
            this.templates.correosExtra = '';
           
        },
        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        downloadTemplate: function (id) {
            let name = id.split("/");
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var referencia = this.templates.referencia;
            var rfc = this.$local_storage.get("rfc");
            let nombre_download = id.split("/").pop();
            axios
                .post(
                    this.$hostname + "catalogos/templates/download/", {
                        id: id,
                        referencia: referencia,
                        rfc: rfc
                    }, {
                        "Content-type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Allow: "POST",
                        "cache-control": "no-cache",
                    }
                )
                .then(response => {
                    if (response.headers["content-type"].search(".zip") != -1 )
                        nombre_download = nombre_download.replace(".docx",".zip");
                    
                    var bytes = this.base64ToArrayBuffer(response.data);
                    let blob = new Blob([bytes], {
                            type: response.headers["content-type"]
                        }),
                        url = window.URL.createObjectURL(blob);

                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = nombre_download;
                    a.click();
                    a.parentNode.removeChild(a);
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al descargar el reporte.",
                        footer: ""
                    });
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        hasSend: function (url) {
            let name = url.split('/');
            let mails = this.templates.emails_enviados

            if (mails != undefined && mails.includes(name[name.length - 1]))
                return true;
        }
    }
};
</script>
<style scoped>
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active), .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon, .theme--light.v-tabs > .v-tabs-bar .v-tab--disabled {
    color:black;
    font-size: small;
    background-color: #EEEEEE;
    padding: 0px;
}
.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small ;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;
  
}
.v-tabs-slider-wrapper {
    left: 0 !important;
}
.table-bordered thead th, .table-bordered thead td {
    font-size: x-small !important;
}
</style>
<style>
.show-modal {
    cursor: pointer;
    border-bottom: 1px dotted;
}
</style>
